/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ExportD9TableDashboardsD9TableExcelGet$Params {
  /**
   * ID проекта
   */
  project_id: number;

  /**
   * ID сценария; дефолт — активный
   */
  scenario_id?: number | null;
  from?: string | null;
  to?: string | null;
  granularity?: 'month' | 'quarter' | 'year';
}

export function exportD9TableDashboardsD9TableExcelGet(
  http: HttpClient,
  rootUrl: string,
  params: ExportD9TableDashboardsD9TableExcelGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, exportD9TableDashboardsD9TableExcelGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('granularity', params.granularity, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<any>;
    }),
  );
}

exportD9TableDashboardsD9TableExcelGet.PATH = '/dashboards/d9/table/excel';
